import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Home, Users, Settings, LogOut, BookImage } from "lucide-react";
import Images from "../../Assets/Images";
import "./SideBar.css";

const SideBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selected, setSelected] = useState(location.pathname);

  useEffect(() => {
    setSelected(location.pathname);
  }, [location]);

  const handleNavigate = (path) => {
    setSelected(path);
    navigate(path);
  };

  const handelBtnClear = () => {
    localStorage.clear("token")
    navigate("/")
  }

  return (
    <div className="sidebar">
      <div className="sidebar_logo flex justify-center">
        <img
          src={Images.logo_bg}
          alt="Logo"
          className="w-1/2 md:w-1/3 lg:w-1/4 h-auto"
        />
      </div>

      <nav className="sidebar_nav">
        <button
          className={`sidebar_link ${selected === "/" ? "active" : ""}`}
          onClick={() => handleNavigate("/")}
        >
          <Home size={20} />
          <span>DashBoard</span>
        </button>
        <button
          className={`sidebar_link ${selected === "/Appearance" ? "active" : ""
            }`}
          onClick={() => handleNavigate("/Appearance")}
        >
          <BookImage size={20} />
          <span>Menu</span>
        </button>
        <button
          className={`sidebar_link ${selected === "/Analytics" ? "active" : ""
            }`}
          onClick={() => handleNavigate("/Analytics")}
        >
          <Users size={20} />
          <span>App user</span>
        </button>
         <button
          className={`sidebar_link ${selected === "/Analytics" ? "active" : ""
            }`}
          onClick={() => handleNavigate("/Analytics")}
        >
          <Users size={20} />
          <span>Promo Code</span>
        </button>
         <button
          className={`sidebar_link ${selected === "/Analytics" ? "active" : ""
            }`}
          onClick={() => handleNavigate("/Analytics")}
        >
          <Users size={20} />
          <span>Delivery Boy</span>
        </button>
         <button
          className={`sidebar_link ${selected === "/Analytics" ? "active" : ""
            }`}
          onClick={() => handleNavigate("/Analytics")}
        >
          <Users size={20} />
          <span>Report</span>
        </button>
        <button
          className={`sidebar_link ${selected === "/Settings" ? "active" : ""}`}
          onClick={() => handleNavigate("/Settings")}
        >
          <Settings size={20} />
          <span>Settings</span>
        </button>
      </nav>



      <div className="sidebar_logout">
        <button
          className="sidebar_logout_btn "

          onClick={handelBtnClear}
        >
          <LogOut size={20} />
          <span>LogOut</span>
        </button>
      </div>
    </div>
  );
};

export default SideBar;
